// SCRNITM#fx
export default [
  {
    name: 'MerchantDeveloperPage',
    path: '/developer',
    meta: {
      auth: false
    },
    component: () => import(/* webpackChunkName: "developer" */ './Index.vue')
  }
]
